import { Play } from '@phosphor-icons/react';

export default Play;
